import "./app.scss";
import Header from "./components/Header/Header";
import IntroDescription from "./components/IntroDescription/IntroDescription";
import { userInfo } from "./config/requests";
import { Web2User } from "./models/model";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { notification } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Contacts } from "src/components/contacts";
import { Slider } from "src/components/slider";
import { useAccount } from "wagmi";

export default function App() {
  const [user, setUser] = useState<Web2User>();
  const location = useLocation();
  const navigate = useNavigate();
  const { isConnected } = useAccount();
  const [tonConnectUI] = useTonConnectUI();

  const getConnection = useCallback(async () => {
    const response = await userInfo();

    if (response.status === 401) {
      setUser(undefined);
      return;
    }

    const json = await response.json();
    setUser(json["user"]);

    if (!isConnected && tonConnectUI.connected) {
      await tonConnectUI.connectionRestored;
      console.log("Connection restored");
    }
  }, [isConnected, tonConnectUI]);

  useEffect(() => {
    getConnection();
  }, [getConnection]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("success") === "true") {
      notification.success({
        message: "Successful purchase",
        description:
          "Please wait a couple of minutes and your purchase will be displayed",
        duration: 10,
      });
      navigate("/");
    }
  }, [location.search, navigate]);

  const username = user?.username?.split("@")[0];

  return (
    <>
      <Header username={username} updateProfile={getConnection} />
      <main>
        <IntroDescription />
        <Slider username={username} updateProfile={getConnection} />
      </main>
      <Contacts />
    </>
  );
}
